// libraries
import React, { useContext, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

// react hooks
import { GlobalContext } from '../../state-manager/globalState';
import webinarImageFile from '../../public/webinars.jpg';
import ProfSahu from '../../public/ProfSahu.jpg';
import MrAmey from '../../public/MrAmey.jpg';

import logoKJ from '../../public/logoKJCropped.png';
import aicte from '../../public/aicte.png';
import mu from '../../public/mu.png';
import svv from '../../public/svv.png';
import intersnhip from '../../public/checklist1.png';
import GoogleAd from '../GoogleAd';
import axios from 'axios';
// components
import WebinarCard from './WebinarCard';
import WebinarCard2 from './WebinarCard2';
import iiclogo from '../../public/iiclogo2.png';
import icast from '../../public/icast.png';

function Webinars() {
  // const { countries } = useContext(GlobalContext);
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    setIsLoading(true);
    axios
      .get('https://kjsieitevents.herokuapp.com/getAllEvents')
      .then(response => {
        setEvents(response.data.events);
      })
      .catch(err => {});
    // setwebinar(webinarDetails[id]);
    setIsLoading(false);
  }, []);
  const countries = {
    data: [
      {
        id: 'ICAST2021',
        speaker: 'KJSIEIT',
        name: 'ICAST 2021',
        details: '4th International Conference on Advances in Science and Technology',
        participants: 533,
        status: 'icast',
        image: icast
      },
      {
        id: 'INNOVATHON',
        speaker: 'Institution Innovation Council (IIC)',
        name: 'Innovathon 2021',
        details: '24 hours Virtual Hackathon',
        participants: 60,
        status: 'hack',
        image: iiclogo
      },
      {
        id: 'DEBATE',
        speaker: 'Institution Innovation Council (IIC)',
        name: 'Innovation Debate 2021',
        details: 'Debate Competition for Innovative Minds',
        participants: 17,
        status: 'debate',
        image: iiclogo
      },
      {
        id: 'FOPOS2021',
        speaker: 'University of Mumbai',
        name: 'Faculty Orientation Programme (FOP)',
        details: 'Course: Operating Systems (ITC403) & Lab: Unix Lab (ITL402)',
        participants: 45,
        ytviews: 1963,

        status: 'fopos',
        image: svv
      },
      {
        id: 'STTP2021AI2',
        speaker: 'AICTE SPONSORED VIRTUAL STTP',
        name: 'SHORT TERM TRAINING PROGRAMME - S2',
        details: 'Leveraging AI & Data Analytics - Healthcare',
        participants: 92,
        ytviews: 1963,

        status: 'sttp2',
        image: aicte
      },
      {
        id: 'STTP2021AI',
        speaker: 'AICTE SPONSORED VIRTUAL STTP',
        name: 'SHORT TERM TRAINING PROGRAMME - S1',
        details: 'Leveraging AI & Data Analytics - Healthcare',
        participants: 64,
        ytviews: 1452,

        status: 'sttp1',
        image: aicte
      },
      {
        id: 'SummerInternship2020',
        image: 'fj',
        speaker: 'Information Technology',
        name: 'Summer Internship',
        details: 'Towards Industry 4.0',
        participants: 205,
        ytviews: 8110,

        status: 'intern',
        image: intersnhip
      },
      {
        id: 'webinar1',
        image: 'fj',
        speaker: 'Dr. G. P. Sahu',
        name: 'NLWS : Webinar 1',
        details: 'Artificial Intelligence',
        participants: 2100,

        ytviews: 9033,
        status: 'wz',
        image: ProfSahu
      },
      {
        id: 'webinar2',
        image: 'fj',
        speaker: 'Mr. Amey Tambe',
        name: 'NLWS : Webinar 2',
        details: 'Cyber Security',
        participants: 1909,
        ytviews: 8110,

        status: 'sz',
        image: MrAmey
      }
    ]
  };
  const [filtredCountries, setFiltredCountries] = useState(countries);
  const data = countries.data || filtredCountries.data;

  return (
    <div className="webinars">
      <Helmet>
        <title>
          {' '}
          {`Events - K. J. Somaiya Institute of Engineering and Information Technology`}
        </title>
        <meta
          name="description"
          content={
            'Events - K. J. Somaiya Institute of Engineering and Information Technology'
          }
        />
      </Helmet>
      <img src={logoKJ} width="95%"></img>
      <div className="socials">
      <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://kjsieit.somaiya.edu"
          className="social-icon icon-only li"
        >
          <i className="fa fa-globe" />
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.youtube.com/c/KJSIEITofficial"
          className="social-icon icon-only yt"
        >
          <i className="fab fa-youtube" />
        </a>
        <a
          href="https://www.facebook.com/kjsieitofficial"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon icon-only li"
        >
          <i className="fab fa-facebook-square" />
        </a>
        <a
          href="https://www.instagram.com/kjsieit_22"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon icon-only gi"
        >
          <i className="fab fa-instagram" />
        </a>
      </div>
      <h1 style={{ textAlign: 'center', color: '#020266' }} className="info">
        Events
      </h1>
      {/* <h1 style={{textAlign:"center"} }className="info"> National-Level Webinar Series  <br></br> on   <br></br>"Emerging Areas of Technology"</h1> */}
      {/* <div className={`hashTitle`}>
        <h4>National-Level Webinar Series</h4>

        <h4>on</h4>
        <h4>"Emerging Areas of Technology"</h4>
      </div> */}
      <div className="container">
      {events.map(webinar => (
          <WebinarCard2 key={webinar._id} {...webinar} />
        ))}
        {data.map(webinar => (
          <WebinarCard key={webinar.id} {...webinar} />
        ))}
      </div>
      {/* <div className="image">
        <img width="120%" height="90%" src={webinarImageFile} />
      </div> */}
      {/* <GoogleAd slot="394738798" timeout={1000} classNames="page-bottom" /> */}
    </div>
  );
}

export default Webinars;
